$(document).ready(function(){
   
$(".custom_stick.sticky_popup .close-btn").click(function(){
   $(".custom_stick.sticky_popup ").removeClass('active_pre_order');
  });
$(".video_section").on('click', function() {
  $(".custom-model-main.image_block").addClass('model-open');
  $(".custom-model-main.image_block.model-open .close-btn").click(function(){
       console.log("fdsfs");
$('.cstm_youtube_video').each(function(index) {
        $(this).attr('src', $(this).attr('src'));
        return false;
      });
});
}); 
  $(".video_section_1").on('click', function() {
  $(".custom-model-main.made_with_text").addClass('model-open');
     $(".custom-model-main.made_with_text.model-open .close-btn").click(function(){
       console.log("video_pause")
  $('.cstm_youtube_video_2').each(function(index) {
        $(this).attr('src', $(this).attr('src'));
        return false;
      });
  });
}); 
$(".get_notify_popup .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
  $(".made_with_text .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
    $(".image_block .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
     $(".pre_order .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
   $(".shipping_popup .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
   $(".money_back_popup .close-btn").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
  $(".custom_right_block_inner, .kalrna_img").on('click', function() {
  $(".custom_model_1").addClass('model-open');
   
}); 
$(".custom_model_1 .close-btn").click(function(){
  $(".custom_model_1").removeClass('model-open');
});
 

  
var year = $('span#timer_counter').attr("data-year");
var month = $('span#timer_counter').attr("data-month");
var day = $('span#timer_counter').attr("data-day");
var hour = $('span#timer_counter').attr("data-hour");
var min = $('span#timer_counter').attr("data-minute");
var seconds = ":00";
var data = month +" "+ day + ", "+ year+" "+ hour + ":"+min+ seconds;
// console.log(data);
//   var data = "Feb 16, 2025 17:07:25"
  
var countDownDate = new Date(data).getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
    
  // Find the distance between now and the count down date
  var distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Output the result in an element with id="timer_counter"
  document.getElementById("timer_counter").innerHTML = days + "D <span></span> " + hours + "H <span></span> "
  + minutes + "M";

   document.getElementById("timer_counter1").innerHTML = days + "D <span></span> " + hours + "H <span></span> "
  + minutes + "M";
   document.getElementById("timer_counter2").innerHTML = days + "D <span></span> " + hours + "H <span></span> "
  + minutes + "M";
   document.getElementById("timer_counter3").innerHTML = days + "D <span></span> " + hours + "H <span></span> "
  + minutes + "M";
   document.getElementById("timer_counter4").innerHTML = days + "D <span></span> " + hours + "H <span></span> "
  + minutes + "M";
    
  // If the count down is over, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("timer_counter").innerHTML = "Soon ";
    document.getElementById("timer_counter1").innerHTML = "Soon ";
    document.getElementById("timer_counter2").innerHTML = "Soon ";
    document.getElementById("timer_counter3").innerHTML = "Soon ";
    document.getElementById("timer_counter4").innerHTML = "Soon ";
  }
}, 1000);

 
   
// $('.custom_block_innner').slick({
//   dots: false,
//   infinite: false,
//   arrows:true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 767,
//       settings: {
//       autoplay:true,
//       infinite: true,
//       autoplaySpeed:1500,
//       arrows:true,
//       centerMode:false,
//       slidesToShow:1,
//       slidesToScroll:1
//       }
//     }
//   ]
// });

// $('a.link.link--text.list-menu__item.list-menu__item--link[menu_value="Rover"]').on('click', function(){
//    $('.stick_product_2_title.cstm-pdp-title[pdp_id="product_stick_2"]').trigger("click");
  
// });
//   $('a.link.link--text.list-menu__item.list-menu__item--link[menu_value="Rover Heat"]').on('click', function(){
//    $('.stick_product_1_title.cstm-pdp-title[pdp_id="product_stick_1"]').trigger("click");
  
// });
  if ($(window).width() < 767) {
//     $('a.link.link--text.list-menu__item.list-menu__item--link[menu_value="Rover"]').on('click', function(){
//    $('li.cstm-pdp-title.cstm_mobile[drop_down_title="Rover"]').trigger("click");
// });
//     $('a.link.link--text.list-menu__item.list-menu__item--link[menu_value="Rover Heat"]').on('click', function(){
//    $('li.cstm-pdp-title.cstm_mobile[drop_down_title="Rover Heat"]').trigger("click");
// });
      $('.button.btn_preorder').click(function() {
      $('li.cstm-pdp-title.cstm_mobile[drop_down_title="Rover X"]').trigger("click");
      $('li.cstm-pdp-title.cstm_mobile[drop_down_title="Rover X"]').trigger("click");
    });
  }
   if ($(window).width() > 767) {
   $('.button.btn_preorder').click(function() {
    $('.stick_product_2_title.cstm-pdp-title[pdp_id="product_stick_2"]').trigger("click");
    });
   }
  mobileOnlySlider(".custom_block_innner", true, true, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    prevArrow:'<button class="prev_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5625 5.25L19.3125 12L12.5625 18.75M18.375 12L4.6875 12" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></svg></button>',
    nextArrow:'<button class="next_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5625 5.25L19.3125 12L12.5625 18.75M18.375 12L4.6875 12" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></svg></button>',

    arrows: $arrows,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

$('.product_2_start').click(function() {
    $('.product_2_start').removeClass("active");
    $('.product_two').removeClass("active");
    $(this).addClass("active");
 var main_id= $(this).attr("data_tab");
    $('#'+main_id).addClass("active");
});

// ------shipping_popup--------
$("a.link.link--text.list-menu__item.list-menu__item--link[menu_value='Shipping'], .shiping_popup_open").click(function() {
     $(".custom-model-main.shipping_popup").addClass('model-open');
 
}); 
  
  // ------------moneyback_popup---------
 $("a.link.link--text.list-menu__item.list-menu__item--link[menu_value='Money-Back Guaranteed']").click(function() {
     $(".custom-model-main.money_back_popup").addClass('model-open');
  // ----------rover footer-----
});
//   $("a.link.link--text.list-menu__item.list-menu__item--link[menu_value='Rover']").click(function() {
//     $('.custom_stick.sticky_popup').addClass("active_pre_order");
  
// });
  // --------rover heat------
//     $("a.link.link--text.list-menu__item.list-menu__item--link[menu_value='Rover Heat'], .cart_sticky.btn_preorder").click(function() {
//     $('.custom_stick.sticky_popup').addClass("active_pre_order");
  
// });

  // ----stick cart add classes-----

  $('.cstm-pdp-title').click(function() {
    $('.cstm-pdp-title').removeClass("active_product");
    $('.product_stick_1').removeClass("active_product");
     $('.product_stick_2').removeClass("active_product");
    $(this).addClass("active_product");
 var main_id= $(this).attr("pdp_id");
    $('.'+main_id).addClass("active_product");
});
  // ---------pre-order add class----
  $('.button.btn_preorder').click(function() {
    localStorage.setItem('local-storage',"cookieset");
    $('.custom_stick.sticky_popup').addClass("active_pre_order");
});
  

  // -------notify form----
  $('.Custom-notify-section .notify_button').on('click', function(){
  
   $('.Custom-notify-section button.needsclick.go3894874857.kl-private-reset-css-Xuajs1').trigger("click");
});

  $('.footer__content-top .notify_button').on('click', function(){
   $('.footer__content-top button.needsclick.go3894874857.kl-private-reset-css-Xuajs1').trigger("click");
});
})
$( window ).on("load", function() {
    var url      = window.location.href; 
  $('.pre_order .close-btn').click(function() {
localStorage.setItem('local-storage',"cookieset");
});
  $('.get_notify_popup .close-btn').click(function() {
localStorage.setItem('Landing_page',"Landing_page_cookie");
});
  var cookie_set = localStorage.getItem('local-storage');
    console.log(cookie_set);
  if (url == 'https://battalion-smart-toolbox.myshopify.com/'){
      if (cookie_set == null){
   setTimeout (function () {
$('.custom-model-main.pre_order').addClass("model-open");
   },30000);
  }
  }
  var cookie_landing = localStorage.getItem('Landing_page');
    console.log(cookie_landing);
  if (url == 'https://battalion-smart-toolbox.myshopify.com/pages/the-worlds-first-heated-toolbox'){
    if (cookie_landing == null){
    setTimeout (function () {
$('.custom-model-main.get_notify_popup').addClass("model-open");
   },30000);
  }
  }
$('li#Compare, #HeaderDrawer-compare').click(function() {
            window.location.href= "https://battaliontool.com/products/rover-x/#compare"
          });
   if(window.location.href != 'https://battaliontool.com/'){
  $('li#Highlights').click(function() {
              window.location.href= "https://battalion-smart-toolbox.myshopify.com/#highlights"
            });
   }
  if(window.location.href.indexOf("help-center") > -1)
       {
              $('li#Highlights').click(function() {
              window.location.href= "https://battalion-smart-toolbox.myshopify.com/#highlights"
            });
          $('li#Compare').click(function() {
            window.location.href= "https://battaliontool.com/products/rover-x/#compare"
          });
        }
    if(window.location.href.indexOf("cart") > -1)
         {
              $('li#Highlights').click(function() {
              window.location.href= "https://battalion-smart-toolbox.myshopify.com/#highlights"
            });
          $('li#Compare').click(function() {
            window.location.href= "https://battaliontool.com/products/rover-x/#compare"
          });
        }
if(window.location.href.indexOf("rover-x") > -1){
   $('.product_2_start.pdp-three-tab').trigger('click');
}
 
// ------li#Get-Notified-----

$('li#Get-Notified, .subscribe_popup').click(function() {
$('.custom-model-main.get_notify_popup').addClass("model-open");
});
// -------become a retailer --------

  $("a.link.link--text.list-menu__item.list-menu__item--link[menu_value='Become a Retailer']").click(function() {
      window.location.href='https://battalion-smart-toolbox.myshopify.com/pages/help-center/#Become-A-Retailer';   
  
});
   


// --------slide down--------
   $('.kalrana_data .view_text_wrapper').on('click', function() {
    $( ".stick_product_1 .custom_img_section .sticky_product_img" ).trigger( "click" );
    });

  // $(window).on('scroll', function() {
  //         $.fn.isInViewport = function() {
  //             var elementTop = $(this).offset().top;
  //             var elementBottom = elementTop + $(this).outerHeight();
 
  //             var viewportTop = $(window).scrollTop();
  //             var viewportBottom = viewportTop + $(window).height();
  //         if ( viewportTop == '3545'){}
  //             return elementBottom > viewportTop && elementTop < viewportBottom;
  //         };
  //         $(window).on('resize scroll', function() {
  //             if ($('#shopify-section-sections--18586555810059__footer').isInViewport()) {
  //               $('.sunshine').addClass("sun_stable")
 
  //             }
  //           else{
  //             $('.sunshine').removeClass("sun_stable")
  //           }
  //         });
  //     });
 
});